import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';
import moment from 'moment'

class SubmitOrder extends Event {
    eventName = 'oms_submitOrder';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for submit order
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        // let order_currency=data.order_currency;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'order_place';
        let form = data.form;
        let flashDelivery = data.flash_delivery;
        let discountCode = data.discount_code;

        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
        let selectedProducts = new LocalStorage.CartLocation(currentLocation).getData();
        let settings = new LocalStorage.ClientSettings(clientId).getData();
        let products = [];

        if (settings) {
            settings = settings.data.data;
        }

        if (selectedProducts && Object.keys(selectedProducts).length > 0) {
            Object.keys(selectedProducts).forEach (function (item) {
                products.push({
                    "id": item,
                    "count": selectedProducts[item].item_qty
                });
            });
        }

        let orderDetails = new LocalStorage.OrderDetails(clientId).getData();

        if (orderDetails && orderDetails.data) {
            orderDetails = orderDetails.data;
        }

        if (clientId && orderDetails) {
            let formData = null;
            let userInfoCity = (orderDetails.user_info.city && orderDetails.user_info.city.city) ? orderDetails.user_info.city.city : orderDetails.user_info.city;

            //custom fields
            let moreInfo = [];
            if (orderDetails.more_info && Object.keys(orderDetails.more_info).length > 0) {
                Object.keys(orderDetails.more_info).forEach (function (item) {
                    moreInfo.push({
                        "sys_attribute_id": item,
                        "sys_attribute_value": orderDetails.more_info[item].value
                    });
                });
            }

            orderDetails.user_info.contact = (orderDetails.user_info.contact) ? orderDetails.user_info.contact : orderDetails.user_info.contact_number;

            if (form == 'inquire') {

                formData = {
                    products: JSON.stringify(products),
                    order_origin: 'ONLINE',
                    // order_currency:order_currency,
                    flash_delivery: flashDelivery,
                    order_instruction: orderDetails.instruction,
                    total: data.subTotal,
                    client_id: clientId,
                    location_id: currentLocation,
                    name: orderDetails.user_info.name,
                    last_name: orderDetails.user_info.last_name,
                    calling_code: orderDetails.user_info.calling_code,
                    contact_number: orderDetails.user_info.calling_code + orderDetails.user_info.contact,
                    contact: orderDetails.user_info.contact,
                    email: orderDetails.user_info.email,
                    address: orderDetails.user_info.address,
                    address_line2: orderDetails.user_info.address_line2,
                    state: orderDetails.user_info.state,
                    country: orderDetails.user_info.country_code,
                    city: userInfoCity,
                    zip: orderDetails.user_info.postal_code,
                    more_info: (orderDetails.more_info) ? JSON.stringify(moreInfo) : null
                }
            }
            else {
                let countryName = (orderDetails.user_info.country && orderDetails.user_info.country.name) ? orderDetails.user_info.country.name : orderDetails.user_info.country;

                //user address
                let userAddress = (orderDetails.user_info.address) ? orderDetails.user_info.address + ', ' : '';
                userAddress = (userInfoCity) ? userAddress + userInfoCity + ', ' : userAddress;
                userAddress = (orderDetails.user_info.state) ? userAddress + orderDetails.user_info.state + ', ' : userAddress;
                userAddress = userAddress + countryName;

                //shipping address
                let shippingAddress = {
                  address: orderDetails.delivery_info.shipping_address_line1,
                  address_line2: orderDetails.delivery_info.shipping_address_line2,
                  state: orderDetails.delivery_info.shipping_state,
                  country: orderDetails.delivery_info.shipping_country_code,
                  city: (orderDetails.delivery_info.shipping_city && orderDetails.delivery_info.shipping_city.city) ? orderDetails.delivery_info.shipping_city.city : orderDetails.delivery_info.shipping_city,
                  zip: orderDetails.delivery_info.shipping_zip,
                  location_id: currentLocation,
                  region: orderDetails.delivery_info.region,
                };

                if (settings.enable_address_separation != '1' && orderDetails.delivery_info.orderType == 'Delivery') {
                    shippingAddress.address = orderDetails.user_info.address;
                    shippingAddress.state = orderDetails.user_info.state;
                    shippingAddress.shipping_country_code = orderDetails.user_info.country_code;
                    shippingAddress.city = userInfoCity;
                    shippingAddress.zip = orderDetails.user_info.zip;
                    shippingAddress.country = (orderDetails.delivery_info.shipping_country && orderDetails.delivery_info.shipping_country.code) ? orderDetails.delivery_info.shipping_country.code : orderDetails.delivery_info.shipping_country;

                    if (!shippingAddress.country) {
                        shippingAddress.country = (orderDetails.user_info.country && orderDetails.user_info.country.code) ? orderDetails.user_info.country.code : orderDetails.user_info.country;
                    }
                }


                formData = {
                    products: JSON.stringify(products),
                    order_origin: 'ONLINE',
                    flash_delivery: flashDelivery,
                    // order_currency:order_currency,
                    order_instruction: orderDetails.instruction,
                    redeem_points: orderDetails.payment_info.loyaltyPoints,
                    user_address: userAddress,
                    additional_field: null,
                    client_id: clientId,
                    location_id: currentLocation,
                    name: orderDetails.user_info.name,
                    last_name: orderDetails.user_info.last_name,
                    calling_code: orderDetails.user_info.calling_code,
                    contact_number: orderDetails.user_info.calling_code + orderDetails.user_info.contact,
                    contact: orderDetails.user_info.contact,
                    email: orderDetails.user_info.email,
                    address: orderDetails.user_info.address,
                    address_line2: orderDetails.user_info.address_line2,
                    state: orderDetails.user_info.state,
                    country: orderDetails.user_info.country_code,
                    city: userInfoCity,
                    zip: orderDetails.user_info.zip,
                    type: orderDetails.delivery_info.orderType,
                    shipping_first_name: orderDetails.delivery_info.shipping_first_name,
                    shipping_last_name: orderDetails.delivery_info.shipping_last_name,
                    shipping_contact_number: orderDetails.delivery_info.shipping_contact_number,
                    delivery_date: orderDetails.delivery_info.date,
                    delivery_time: (orderDetails.delivery_info.time) ? moment(orderDetails.delivery_info.time, "hh:mm a").format('HH:mm') : null,
                    shipping_address_info: (shippingAddress) ? JSON.stringify(shippingAddress) : null,
                    shipping_main_method: orderDetails.delivery_info.deliveryMainMethod,
                    shipping_delivery_method: orderDetails.delivery_info.deliveryMethod,
                    delivery_method_name: orderDetails.delivery_info.deliveryMethodName,
                    shipping_config: (orderDetails.delivery_info.shippingConfig) ? JSON.stringify(orderDetails.delivery_info.shippingConfig) : null,
                    delivery_address: userAddress + (orderDetails.delivery_info.region) ? ', ' + orderDetails.delivery_info.region : '',
                    shipping_region: orderDetails.delivery_info.region,
                    region: orderDetails.delivery_info.region,
                    payment_method: orderDetails.payment_info.paymentMethod.name,
                    payment_method_id: orderDetails.payment_info.paymentMethod.id,
                    more_info: (orderDetails.more_info) ? JSON.stringify(moreInfo) : null,
                    discount_code: (discountCode) ? discountCode : null
                }
            }

            if (formData) {

                // request data
                data.endPoint = application_settings.endPoints.createOrder;
                data.method = 'POST';
                data.multi_call_key = multiCallKey;
                data.publicAuth = (data.is_user_login == false) ? true : false;
                data.data = formData;
            
                // send request
                thisObj.sendRequest(data, function (response) {
                  if (response) {
                    //format response data
                    let data = thisObj.formatResponseData(response);

                    if (response.data) {
                        orderDetails.order_info = response.data;
                        orderDetails.order_form = form;
                        orderDetails.user_info.address_id = null;
                        orderDetails.delivery_info.address_id = null;
                    }

                    // remove discount code
                    if (data.success && discountCode) {
                        let discountCodeData = new LocalStorage.DiscountCode(currentLocation);
                        discountCodeData.removeData();
                    }

                    new LocalStorage.OrderDetails(clientId).setData(orderDetails);

                    //fire success event
                    thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
                  }
                });
            }

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }


}

export default SubmitOrder;